export const WO_FORM_ERROR_INCOMPLETE_REASON = "WO_FORM_ERROR_INCOMPLETE_REASON";
export const WO_FORM_ERROR_INCOMPLETE_SUBREASON = "WO_FORM_ERROR_INCOMPLETE_SUBREASON";
export const WO_FORM_ERROR_INCOMPLETE_COMMENTS = "WO_FORM_ERROR_INCOMPLETE_COMMENTS";
export const WO_FORM_ERROR_INCOMPLETE_DATE = "WO_FORM_ERROR_INCOMPLETE_DATE";

export const WO_FORM_ERROR_COMPLETE_REASON = "WO_FORM_ERROR_COMPLETE_REASON";
export const WO_FORM_ERROR_COMPLETE_SUBREASON = "WO_FORM_ERROR_COMPLETE_SUBREASON";
export const WO_FORM_ERROR_COMPLETE_COMMENTS = "WO_FORM_ERROR_COMPLETE_COMMENTS";

// INCOMPLETE FORM
export const setIncompleteReasonError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_INCOMPLETE_REASON,
        incompleteReason: woFormError,
    };
};

export const setIncompleteSubReasonError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_INCOMPLETE_SUBREASON,
        incompleteSubReason: woFormError,
    };
};

export const setIncompleteCommentError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_INCOMPLETE_COMMENTS,
        additionalComments: woFormError,
    };
};

export const setNewDueDateError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_INCOMPLETE_DATE,
        newDueDate: woFormError,
    };
};

// COMPLETE FORM
export const setCompleteReasonError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_COMPLETE_REASON,
        completeReason: woFormError,
    };
};

export const setCompleteSubReasonError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_COMPLETE_SUBREASON,
        completeSubReason: woFormError,
    };
};

export const setCompleteCommentError = (woFormError) => {
    return {
        type: WO_FORM_ERROR_COMPLETE_COMMENTS,
        completeSubReason: woFormError,
    };
};
